export default "__VITE_ASSET__BoTFx578__"